import { QueryObserverOptions, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '@api/messages';
import getUploadById from '../api';
import { UploadDTO } from '../dto/UploadDTO';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<UploadDTO>, 'enabled'>;

export default function useGetUploadById(id: number, options?: UseQueryOptionsKeys) {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery(['getUploadById', id], () => getUploadById(id), {
    onError: error => {
      errorMessage({
        title: t('error.upload.not.found', { uploadId: id }),
        message: null,
        error,
      });
    },
    ...options,
  });

  return { uploadDTO: data, isFetching };
}
